/* MIDWEEK · Klaviyo reviews: default to the "Product reviews" tab and show
   only the first 3 reviews with a "More reviews" accordion button. */
(function () {
  // one row of tiles: 3 on desktop, 2 on tablet and phone
  function visibleCount() {
    return (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) ? 3 : 2;
  }
  var WRAPPERS = '#klaviyo-all-reviews-wrapper, #klaviyo-product-reviews-wrapper';
  var ITEM = '.kl_reviews__review_item';

  // Product photo in each review card -> our flavor icon (matched by product name)
  var FILES = 'https://cdn.shopify.com/s/files/1/0748/2730/1037/files/';
  var ICONS = [
    { match: /variety/i, src: FILES + 'midweek-variety-icon.webp', flavor: 'variety' },
    { match: /marg/i,    src: FILES + 'midweek-marg-icon.webp',    flavor: 'marg' },
    { match: /mule/i,    src: FILES + 'midweek-mule-icon.webp',    flavor: 'mule' }
  ];
  function swapIcons(root) {
    var cards = root.querySelectorAll('.kl_reviews__review__product_card');
    for (var c = 0; c < cards.length; c++) {
      var img = cards[c].querySelector('img');
      var nameEl = cards[c].querySelector('.kl_reviews__review__product_card__details__name');
      if (!img || !nameEl || img.dataset.mwIcon) continue;
      var name = nameEl.textContent || '';
      for (var k = 0; k < ICONS.length; k++) {
        if (ICONS[k].match.test(name)) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = ICONS[k].src;
          img.alt = '';
          img.dataset.mwIcon = ICONS[k].flavor;
          img.classList.add('mw-rv-icon');
          cards[c].classList.add('mw-rv-icon-card', 'mw-rv-icon-card--' + ICONS[k].flavor);
          break;
        }
      }
    }
  }

  try { console.log('[midweek-reviews] script loaded'); } catch (e) {}

  function setup(wrapper) {
    if (wrapper.dataset.mwRvReady) return;
    wrapper.dataset.mwRvReady = '1';
    var expanded = false;
    var tabDone = false;
    var raf = 0;

    var observer = new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; enhance(); });
    });
    function watch() { observer.observe(wrapper, { childList: true, subtree: true }); }

    // once the visitor picks a tab themselves, never auto-switch again
    wrapper.addEventListener('click', function (e) {
      if (e.isTrusted && e.target.closest('[role="tab"]')) tabDone = true;
    }, true);

    function defaultToProductReviews() {
      if (tabDone) return;
      var tab = wrapper.querySelector('#kl_reviews_tabs__reviews_tab');
      if (!tab) {
        var tabs = wrapper.querySelectorAll('[role="tab"]');
        for (var i = 0; i < tabs.length; i++) {
          if (/product reviews/i.test(tabs[i].textContent || '')) { tab = tabs[i]; break; }
        }
      }
      if (!tab) return;
      tabDone = true;
      if (tab.getAttribute('aria-selected') !== 'true') tab.click();
    }

    function enhance() {
      observer.disconnect();
      try {
        defaultToProductReviews();
        try { swapIcons(wrapper); } catch (e) { /* cosmetic only */ }

        var old = wrapper.querySelectorAll('.mw-rv-more');
        for (var o = 0; o < old.length; o++) old[o].remove();

        var items = wrapper.querySelectorAll(ITEM);
        if (!items.length) return;
        var VISIBLE = visibleCount();

        for (var i = 0; i < items.length; i++) {
          items[i].classList.toggle('mw-rv-hidden', !expanded && i >= VISIBLE);
        }

        // Klaviyo's own "show more" (loads further pages) only while open
        var natives = wrapper.querySelectorAll('.kl_reviews__button');
        for (var n = 0; n < natives.length; n++) {
          if (/more/i.test(natives[n].textContent || '')) natives[n].classList.add('mw-rv-native-more');
        }
        wrapper.classList.toggle('mw-rv-collapsed', !expanded);

        if (items.length > VISIBLE) {
          var list = items[0].parentElement;
          var anchor = list.closest('.kl_reviews__list_container') || list;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mw-rv-more';
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          btn.textContent = expanded ? 'Fewer reviews' : 'More reviews';
          btn.addEventListener('click', function () {
            expanded = !expanded;
            enhance();
          });
          anchor.insertAdjacentElement('afterend', btn);
        }
      } finally {
        watch();
      }
    }

    var lastCount = visibleCount();
    window.addEventListener('resize', function () {
      var now = visibleCount();
      if (now !== lastCount) { lastCount = now; enhance(); }
    });

    enhance();
  }

  function scan() {
    document.querySelectorAll(WRAPPERS).forEach(setup);
  }

  scan();
  var tries = 0;
  var timer = setInterval(function () {
    scan();
    if (++tries > 120) clearInterval(timer); // ~60s, then stop looking
  }, 500);
})();
